module.exports = __webpack_public_path__ + "media/images/flags/1x1/irl-91c08bb8ac2e30128d0762c38dd5e5b0.svg";